import VueRouter, { RouteConfig } from 'vue-router'

const Poster = () => import('../views/summer-2022/Poster.vue')
const Landing = () => import('../views/summer-2022/Landing.vue')
const Statistics = () => import('../views/summer-2022/Statistics.vue')
const DeliveryAddressEdit = () => import('../views/summer-2022/DeliveryAddressEdit.vue')
const SummerPlan2022Create = () => import('../views/summer-2022/CreateSummerPlan2022.vue')
const SafeLessonPlan = () => import('../views/summer-2022/SafeLessonPlanPage.vue')
const HomeworkPlan = () => import('../views/summer-2022/HomeworkPlanPage.vue')
const SpecificTrainingPlan = () => import('../views/summer-2022/SpecificTrainingPlanPage.vue')
const SportsCompetitionPlan = () => import('../views/summer-2022/SportsCompetitionPlanPage.vue')
const LabourLessonPlan = () => import('../views/summer-2022/LabourLessonPlanPage.vue')
const HomeworkList = () => import('../views/summer-2022/HomeworkListPage.vue')

export const posterRoute: RouteConfig = {
  path: '/summer-vacation-2022-poster',
  name: 'summer_vacation_2022_poster',
  component: Poster,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2022暑假体育工作解决方案',
  },
}

export const landingRoute: RouteConfig = {
  path: '/summer-vacation-2022-landing',
  name: 'summer_vacation_2022_landing',
  component: Landing,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2022暑假体育工作解决方案',
  },
}

export const statisticsRoute: RouteConfig = {
  path: '/summer-vacation-2022-statistics',
  name: 'summer_vacation_2022_statistics',
  component: Statistics,
  meta: {
    title: '2022暑假作业',
  },
}

export const deliveryAddressEditRoute: RouteConfig = {
  path: '/summer-vacation-2022-delivery-address-edit',
  name: 'summer_vacation_2022_delivery_address_edit',
  component: DeliveryAddressEdit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '填写收货地址',
  },
}

export const summer2022HomeworkListRoute: RouteConfig = {
  path: '/summer-2022-homework-list',
  name: 'summer_2022_homework_list',
  component: HomeworkList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '暑期作业计划列表',
  },
}
export const summer2022CreatePlanRoute: RouteConfig = {
  path: '/create-summer-2022-plan',
  name: 'crate_summer_2022_plan',
  component: SummerPlan2022Create,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '暑期作业计划',
  },
}

export const safeLessonRoute: RouteConfig = {
  path: '/summer-2022-safe-lesson',
  name: 'summer_2022_safe_lesson',
  component: SafeLessonPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '暑期安全课课程计划',
  },
}
export const homeworkPlanRoute: RouteConfig = {
  path: '/summer-2022-homework-plan',
  name: 'summer_2022_homework_plan',
  component: HomeworkPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业计划',
  },
}

export const specificTrainingPlanRoute: RouteConfig = {
  path: '/specific-training-plan',
  name: 'specific_training_plan',
  component: SpecificTrainingPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '专项训练',
  },
}

export const sportsCompetitionPlanRoute: RouteConfig = {
  path: '/sports-competition-plan',
  name: 'sports_competition_plan',
  component: SportsCompetitionPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育比赛计划',
  },
}
export const labourLessonPlanRoute: RouteConfig = {
  path: '/LabourLessonPlan',
  name: 'LabourLessonPlan',
  component: LabourLessonPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '暑期劳动课',
  },
}

export default [
  posterRoute,
  landingRoute,
  statisticsRoute,
  deliveryAddressEditRoute,
  summer2022HomeworkListRoute,
  summer2022CreatePlanRoute,
  homeworkPlanRoute,
  labourLessonPlanRoute,
  safeLessonRoute,
  specificTrainingPlanRoute,
  sportsCompetitionPlanRoute,
]

export function navigateToSummerVacation2022List(router: VueRouter) {
  router.push({ name: summer2022HomeworkListRoute.name })
}

export function navigateToSummerVacation2022Edit(router: VueRouter) {
  router.push({ name: summer2022CreatePlanRoute.name })
}

export function navigateToSummerVacation2022Poster(router: VueRouter) {
  router.push({ name: posterRoute.name })
}

export function redirectToSummerVacation2022Poster(router: VueRouter) {
  router.replace({ name: posterRoute.name })
}

export function navigateToSummerVacation2022Landing(router: VueRouter, qd?: string) {
  router.push({ name: landingRoute.name, query: { qd } })
}

export function navigateToSummerVacation2022DeliveryAddressEdit(router: VueRouter) {
  router.push({ name: deliveryAddressEditRoute.name })
}

export function redirectToSummerVacation2022DeliveryAddressEdit(router: VueRouter) {
  router.replace({ name: deliveryAddressEditRoute.name })
}

export function navigateToSummerVacation2022SafeLesson(router: VueRouter) {
  router.push({ name: safeLessonRoute.name })
}

export function navigateToSummerVacation2022HomeworkPlan(router: VueRouter) {
  router.push({ name: homeworkPlanRoute.name })
}

export function navigateToSummerVacation2022SportsCompetitionPlan(router: VueRouter) {
  router.push({ name: sportsCompetitionPlanRoute.name })
}

export function navigateToSummerVacation2022sportsCompetitionPlan(router: VueRouter) {
  router.push({ name: sportsCompetitionPlanRoute.name })
}

export function navigateToSummerVacation2022LabourLessonPlan(router: VueRouter) {
  router.push({ name: labourLessonPlanRoute.name })
}

export function navigateToSummerVacation2022SpecificTrainingPlan(router: VueRouter) {
  router.push({ name: specificTrainingPlanRoute.name })
}

export function navigateToSummer2022CreatePlan(router: VueRouter, id?: string) {
  router.push({
    name: summer2022CreatePlanRoute.name,
    query: {
      id,
    },
  })
}

export function navigateToSummer2022List(router: VueRouter) {
  router.push({ name: summer2022HomeworkListRoute.name })
}
